<template>
    <header class="main-header">
        <a
            href=""
            class="sidebar-toggle"
            v-b-toggle="sidebarId"
            @click.prevent
        >
            <!-- <i class="las la-bars"></i> -->
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                style="fill:#fff;width:1.27rem;"
            >
                <path d="M0 96C0 78.33 14.33 64 32 64H416C433.7 64 448 78.33 448 96C448 113.7 433.7 128 416 128H32C14.33 128 0 113.7 0 96zM0 256C0 238.3 14.33 224 32 224H416C433.7 224 448 238.3 448 256C448 273.7 433.7 288 416 288H32C14.33 288 0 273.7 0 256zM416 448H32C14.33 448 0 433.7 0 416C0 398.3 14.33 384 32 384H416C433.7 384 448 398.3 448 416C448 433.7 433.7 448 416 448z" />
            </svg>
        </a>
        <h1>{{ isShowMap ? '地圖導覽' : '川柳不息數位導覽平台' }}</h1>
        <a
            href=""
            @click.prevent="toggleMap"
            class="map-btn"
        >
            <img
                :src="isShowMap ? IconBack : IconMap"
                alt="switch btn"
            />
        </a>
    </header>
</template>

<script>
import IconMap from '@/assets/header_map.svg';
import IconBack from '@/assets/header_back.svg';

export default {
    props: {
        isShowMap: {
            type: Boolean,
            default: false,
        },
        sidebarId: {
            type: String,
            default: 'sidebar',
        },
    },
    data() {
        return {
            IconMap,
            IconBack,
        };
    },
    methods: {
        toggleMap() {
            this.$emit('togglemap');
        },
    },
    watch: {
        isShow(val) {
            if (!val) {
                document.querySelector('.detail-content-wrapper').scrollTop = 0;
            }
        },
    },
};
</script>
